export const IMG_AND_VIDEO = /<img[^>]*>|<video[^>]*>|<\/video[^>]*>|<source[^>]*>/g
